import { useEffect, useRef, useState } from "react";
import { RealtimeManager } from "../realtime";

const useValue = ({ listenEventNames = [], originalValue = null }) => {
    const [value, setValue] = useState(originalValue);

    const valueLatest = useRef(value);

    useEffect(() => {
        valueLatest.current = originalValue;

        setValue(originalValue);
    }, [originalValue]);

    useEffect(() => {
        if (!listenEventNames?.length) {
            return;
        }

        const unsubs = listenEventNames.map((listenEventName) =>
            RealtimeManager.subscribe(listenEventName, (buildValueCallback) => {
                const newValue = buildValueCallback(valueLatest.current);

                valueLatest.current = newValue;

                setValue(newValue);
            }),
        );

        return () => {
            unsubs.forEach((unsub) => {
                unsub();
            });
        };
    }, listenEventNames);

    return value;
};

export default useValue;
